import { FunctionComponent } from 'react'
import Dialog from '@/components/_custom/Dialog/Dialog'
import DialogHeader from '@/components/_custom/DialogHeader/DialogHeader'
import { useTranslation } from 'react-i18next'
import DialogBody from '@/components/_custom/DialogBody/DialogBody'
import { useMutation } from '@apollo/client'
import styles from './deleteDaycareGroupUrlDialog.module.scss'
import ButtonTextIcon from '@/components/_custom/Buttons/ButtonTextIcon/ButtonTextIcon'
import { DELETE_DAYCARE_GROUP_URL } from '@/modules/API/daycareGroup/daycareGroupUrl'
import { DaycareGroupsUrl } from '@/types/DaycareGroup'
import { Close, Delete } from '@mui/icons-material'
import { useNotification } from '@/modules/context/NotificationContext.tsx'

interface DeleteDaycareGroupUrlProps {
    open: boolean
    handleClose: () => void
    url: DaycareGroupsUrl
    refetchUrl: () => void
}

const DeleteDaycareGroupUrlDialog: FunctionComponent<DeleteDaycareGroupUrlProps> = ({
    open,
    handleClose,
    url,
    refetchUrl
}: DeleteDaycareGroupUrlProps) => {
    const { t } = useTranslation()

    const { showNotificationSuccess, showNotificationError } = useNotification()

    const [deleteDaycareGroupUrl] = useMutation(DELETE_DAYCARE_GROUP_URL, {
        variables: {
            groupId: url.daycareGroupId,
            urlId: url.id
        },
        onCompleted: () => {
            showNotificationSuccess(t('urlDeleted'))

            refetchUrl()
            handleClose()
        },
        onError: () => {
            showNotificationError(t('urlDeletedError'))
        }
    })

    return (
        <Dialog open={open} handleClose={handleClose}>
            <DialogHeader title={t('confirmDeleteUrl')} />
            <DialogBody className={styles.DialogBody}>
                <div className={styles.TextContainer}>
                    <p className={styles.Text}>{t('confirmDeleteUrlMessage')}</p>
                    <p className={styles.Text}>{t('noRollBack')}</p>
                </div>
                <div className={styles.ButtonContainer}>
                    <ButtonTextIcon
                        type={'custom'}
                        customText={t('yes')}
                        customIcon={<Delete />}
                        onClick={deleteDaycareGroupUrl}
                        className={styles.Button}
                    />
                    <ButtonTextIcon
                        type={'custom'}
                        customText={t('no')}
                        customIcon={<Close />}
                        onClick={handleClose}
                        className={styles.Button}
                    />
                </div>
            </DialogBody>
        </Dialog>
    )
}

export default DeleteDaycareGroupUrlDialog
